import {TranslationObject} from '@colonist/i18n'
import {ErrorTypes, HTTPStatus} from './ErrorEnums'
import {LogSeverity} from './LogSeverity'

export interface RedirectUrl {
    url: string
    hash: string
}

export abstract class BaseError extends Error {
    abstract readonly type: ErrorTypes

    readonly title: TranslationObject
    readonly description: TranslationObject

    readonly httpStatusCode: HTTPStatus
    readonly logSeverity: LogSeverity

    redirectUrl?: RedirectUrl | undefined

    logError = true

    constructor(title: TranslationObject, message: TranslationObject, httpStatusCode: HTTPStatus, logSeverity: LogSeverity, redirectUrl?: RedirectUrl) {
        super(message.key)
        this.title = title
        this.description = message
        this.httpStatusCode = httpStatusCode
        this.logSeverity = logSeverity
        this.redirectUrl = redirectUrl
    }
}
